import { Component } from '@angular/core';

@Component({
  selector: 'app-empty-chart',
  imports: [],
  templateUrl: './empty-chart.html',
  styleUrl: './empty-chart.css',
})
export class EmptyChart {

}
